/**
 * Проверка
 *
 * @method
 * @private
 */
function _isListen(eventName) {
  const self = this;
  const component = self._component(eventName);
  let status = false;

  if (self._inList(component)) {
    const componentValue = self.loggersList[component];

    status = componentValue.hasOwnProperty(eventName);
  }

  return status;
}

export default _isListen;
